import React from 'react';
import { Table, Button, Input, Icon, Card } from 'antd';
import common from '../../assets/common.js';
import MenuAction from '../../modest/menuaction/index.js'
import './index.css';

class MemberTable extends React.Component {
  delete = (record) => {
    var postData = {};
    postData["_url"] = "";
    postData["_method"] = "DELETE";
    postData["id"] = record.id;
    common.request(postData, this, function(obj, result){
      const pagination = obj.state.table.pagination;
      obj.getList(pagination);
    });
  }
  cancel = (id) =>{
    console.log(id)
  }
  constructor(){
    super();
    let table = {};
    table.id = "proTable";
    table = common.getDefaultTable(table);
    this.state = {
      table,
      batchList : [],
      search : "",
      modalType : "",
      modalData : ""
    }
  }
  componentWillMount(){
    this.showTableCol();
  }
  componentDidMount(){
    this.getList();
  }
  showTableCol = () => {
    let table = this.state.table;
    table.columnsList = [{
      title: '名称',
      dataIndex: 'name',
      must: true,
      show: true,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div className="custom-filter-dropdown">
          <Input
            ref={ele => this.searchInput = ele}
            placeholder="请输入们名称"
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={this.handleSearch(selectedKeys, confirm)}
          />
          <Button type="primary" onClick={this.handleSearch(selectedKeys, confirm)}>搜索</Button>
          <Button onClick={this.handleReset(clearFilters)}>重制</Button>
        </div>
      ),
      filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#108ee9' : '#aaa' }} />,
      onFilter: (value, record) => record.name.toLowerCase().includes(value.toLowerCase()),
      onFilterDropdownVisibleChange: (visible) => {
        if (visible) {
          setTimeout(() => {
            this.searchInput.focus();
          });
        }
      },
      render: (text) => {
        const { searchText } = this.state;
        return searchText ? (
          <span>
            {text.split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')).map((fragment, i) => (
              fragment.toLowerCase() === searchText.toLowerCase()
                ? <span key={i} className="highlight">{fragment}</span> : fragment // eslint-disable-line
            ))}
          </span>
        ) : text;
      },
    }, {
      title: '设备编号',
      dataIndex: 'sn',
      must: false,
      show: true,
    }, {
      title: '更新时间',
      dataIndex: 'update_time',
      must: false,
      show: true,
    }, {
      title: '门禁状态',
      dataIndex: 'status_code',
      must: true,
      show: true,
      width : "120px",
      render: (text, record)=>{
        const content = record.status;
        switch(text){
          case 1:
            text = <span className="status-point status-green">{ content }</span>
            break;
          default :
            text = <span className="status-point status-red">{ content }</span>
            break;
        }
        return text;
      }
    }];
    table = common.getEcardTable(table);
    this.setState({ table });
  }
  changePage = (pagination, filters, sorter) => {
    const table = this.state.table;
    table.pagination = pagination;
    this.setState({ table })
  }
  getList = (pageInfo, filters, sorter) =>{
    const pn = pageInfo ? 1 : pageInfo
    const batchId = this.state.batchId;
    const table = this.state.table;
    var postData = {};
    postData["_url"] = "door_status";
    postData["_method"] = "GET";
    postData["batch_id"] = batchId;
    table.loading = true;
    this.setState({ table });
    common.request(postData, this, function(obj, data){
      const result = data.retData;
      obj.showList(result, pn);
    },function(obj, state){
      table.loading = false;
      obj.setState({ table });
    });
  }
  showList = (result, pn) => {
    const table = this.state.table;
    const list = result;
    table.loading = false;
    var dataSource = [];
    table.pagination = {
      current : pn,
      total : list.length,
    }
    common.eachObj(list, function(index, dataItem){
      var one = dataItem;
      one["key"] = (index + 1);
      dataSource.push(one);
    })
    table.dataSource = dataSource;
    this.setState({ table });
  }
  showModal = (modalType, modalData) => {
    switch(modalType){
      case "releaseend":case "importend":
        this.getList();
        this.setState({ modalType, modalData });
        break;
      default:
        this.setState({ modalType, modalData });
        break;
    }
  }
  handleSearch = (selectedKeys, confirm) => () => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  }

  handleReset = clearFilters => () => {
    clearFilters();
    this.setState({ searchText: '' });
  }
  changeBatch = (batchId) => {
    this.setState({ batchId }, function(){
      this.getList()
    })
  }
  render(){
    const { table } = this.state;
    return(
      <Card>
        <div>
          <div className="table-menu clearfix">
            <div className="pull-right">
            { table.show && <MenuAction obj={ this }/> }
            </div>
          </div>
          <div id="manageTableDiv" className="table-div">
            { table.show && <Table
              { ...table }
              onChange={this.changePage.bind(this)}
            />}
            <div className="table-total">共{ table.pagination.total }条数据</div>
          </div>
        </div>
      </Card>
    )
  }
}
export default MemberTable;



// WEBPACK FOOTER //
// ./src/component/internet/list.js